"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Archive;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Archive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "archive"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M12.75,29.39V80.94a4.53,4.53,0,0,0,4.53,4.53H85.43A4.53,4.53,0,0,0,90,80.94V29.39ZM64.29,50H38.59a4,4,0,0,1-4-3.47,3.86,3.86,0,0,1,3.83-4.24h25.7a4,4,0,0,1,4,3.48A3.85,3.85,0,0,1,64.29,50ZM91,25.48H11.72a1.82,1.82,0,0,1-1.81-1.82v-4.1A4.53,4.53,0,0,1,14.45,15H88.26a4.53,4.53,0,0,1,4.54,4.53v4.1A1.82,1.82,0,0,1,91,25.48Z"
  }))));
}